<template>
  <div v-if="loadingStatus">
    <dl>
      <dt class="stitle1"><SkeletonBox :minWidth="30" :maxWidth="80" /></dt>
      <dd class="colorBox">
        <SkeletonBox :minWidth="80" :maxWidth="100" />
        <SkeletonBox :minWidth="80" :maxWidth="100" />
        <SkeletonBox :minWidth="30" :maxWidth="70" />
      </dd>
    </dl>
  </div>
  <div v-else>
    <dl>
      <dt class="stitle1">{{ productItem.mrktnPdNm }}</dt>
      <dd class="colorBox prodExpl" v-html="productItem.salepdDtlExpl" @click="clickImageMap()"></dd>
    </dl>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ImageMap from '@/utils/js/image-map';

export default {
  name: 'ProductDetailDesc',
  props: [],
  computed: {
    ...mapState('reserve', ['loadingStatus', 'productItem']),
  },
  methods: {
    clickImageMap() {
      //console.log('clickImageMap');
      const imageElement = this.$el.querySelector('img');
      if (imageElement) {
        //console.log(imageElement);
        ImageMap('img[usemap]');
        //console.log('clickImageMap loaded');
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.img-wrap {
  position: relative;
  min-width: 50%;
  min-height: 200px;
}
.round-wrap {
  overflow: hidden;
  border-radius: 20px;
  display: inline-block;
}
img {
  object-fit: cover;
}
</style>
